module.exports = __webpack_public_path__ + "static/odoo-5ecf557af6454d2bf004eb4d366fe804.svg";